import I18n from 'I18n';
import PropTypes from 'prop-types';
import { createRef, Component, Fragment } from 'react';
import styled from 'styled-components';
import omit from 'transmute/omit';
import getIn from 'transmute/getIn';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UITypeahead from 'UIComponents/typeahead/UITypeahead';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getHtmlBodyForOption = (id, options) => getIn(['snippet', 'htmlBody'], options.find(option => option.value === id));
const areOptionsRenderable = options => options && options.length > 0;
const LoadingPositioner = styled.div.withConfig({
  displayName: "ContentTypeahead__LoadingPositioner",
  componentId: "wceehu-0"
})(["align-items:center;display:flex;height:180px;justify-content:center;"]);
const CompactTypeahead = styled(UITypeahead).withConfig({
  displayName: "ContentTypeahead__CompactTypeahead",
  componentId: "wceehu-1"
})([".content-popover-search-results{height:180px;}.content-popover-search{background:none;margin-bottom:12px;padding:0;}"]);
class ContentTypeahead extends Component {
  constructor(...args) {
    super(...args);
    this.handleChange = e => {
      // @ts-expect-error ts-migrate FIXME
      const {
        onChange,
        options
      } = this.props;
      const id = e.target.value;
      const htmlBody = getHtmlBodyForOption(id, options);
      const version = options.find(option => option.value === id).version;
      onChange({
        id,
        htmlBody,
        version
      });
    };
  }
  componentDidUpdate(prevProps) {
    const {
      isLoading: wasLoading,
      options: prevOptions
    } = prevProps;
    // @ts-expect-error ts-migrate FIXME
    const {
      isLoading,
      options
    } = this.props;
    const didPreviouslyRenderTypeahead = areOptionsRenderable(prevOptions);
    const isTypeaheadRendered = areOptionsRenderable(options);
    if ((!didPreviouslyRenderTypeahead && isTypeaheadRendered || wasLoading && !isLoading) &&
    // @ts-expect-error ts-migrate FIXME
    this._inputRef &&
    // @ts-expect-error ts-migrate FIXME
    this._inputRef.current) {
      // @ts-expect-error ts-migrate FIXME
      this._inputRef.current.focus();
    }
  }
  renderLoadingSpinner() {
    // @ts-expect-error ts-migrate FIXME
    const {
      isLoading
    } = this.props;
    if (isLoading) {
      return /*#__PURE__*/_jsx(LoadingPositioner, {
        children: /*#__PURE__*/_jsx(UILoadingSpinner, {})
      });
    }
    return null;
  }
  render() {
    const {
      // @ts-expect-error ts-migrate FIXME
      EmptyState,
      // @ts-expect-error ts-migrate FIXME
      ErrorState,
      // @ts-expect-error ts-migrate FIXME
      search,
      // @ts-expect-error ts-migrate FIXME
      handleSearch,
      options,
      // @ts-expect-error ts-migrate FIXME
      isLoading,
      // @ts-expect-error ts-migrate FIXME
      portalId,
      // @ts-expect-error ts-migrate FIXME
      searchPlaceHolder
    } = this.props;
    if (isLoading && search.length === 0) {
      return this.renderLoadingSpinner();
    }
    if (!options) {
      return /*#__PURE__*/_jsx(ErrorState, {
        portalId: portalId
      });
    }
    if (options.length === 0 && search.length === 0 && !isLoading) {
      return /*#__PURE__*/_jsx(EmptyState, {
        portalId: portalId
      });
    }

    // @ts-expect-error ts-migrate FIXME
    this._inputRef = this._inputRef || /*#__PURE__*/createRef();
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(CompactTypeahead, {
        autoFilter: false,
        options: options,
        placeholder: I18n.text(searchPlaceHolder),
        resultsClassName: "content-popover-search-results",
        searchClassName: "content-popover-search",
        onChange: this.handleChange,
        search: search,
        onSearchChange: event => handleSearch(event, omit(['results'], options))
        // @ts-expect-error ts-migrate FIXME
        ,
        inputRef: this._inputRef,
        hideResults: isLoading
      }), this.renderLoadingSpinner()]
    });
  }
}

// @ts-expect-error ts-migrate FIXME
ContentTypeahead.propTypes = {
  ErrorState: PropTypes.func.isRequired,
  EmptyState: PropTypes.func.isRequired,
  search: PropTypes.string,
  handleSearch: PropTypes.func,
  onChange: PropTypes.func,
  options: PropTypes.array,
  isLoading: PropTypes.bool,
  portalId: PropTypes.number.isRequired,
  searchPlaceHolder: PropTypes.string.isRequired
};
export default ContentTypeahead;